// src/pages/Accounting/Receipts/components/ViewDrawer/DrawerActions.tsx

import { PALETTE } from "../../constants";

interface DrawerActionsProps {
  onEdit: () => void;
  onUnmatch: () => void;
  onDelete: () => void;
  canUnmatch: boolean;
}

export function DrawerActions({
  onEdit,
  onUnmatch,
  onDelete,
  canUnmatch,
}: DrawerActionsProps) {
  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        padding: "14px 22px",
        background: "#FBFBFB",
        borderTop: `1px solid ${PALETTE.line}`,
        display: "flex",
        gap: 10,
        alignItems: "center",
      }}
    >
      <button
        type="button"
        onClick={onEdit}
        style={{
          background: "#0E1A1A",
          color: "#fff",
          border: 0,
          fontWeight: 600,
          fontSize: 13,
          padding: "9px 14px",
          borderRadius: 9,
          cursor: "pointer",
          boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
        }}
      >
        Edit details
      </button>
      {canUnmatch && (
        <button
          type="button"
          onClick={onUnmatch}
          style={{
            background: "transparent",
            border: 0,
            color: PALETTE.ink2,
            fontWeight: 500,
            fontSize: 13,
            padding: "9px 10px",
            cursor: "pointer",
          }}
        >
          Unmatch
        </button>
      )}
      <button
        type="button"
        onClick={onDelete}
        style={{
          background: "transparent",
          border: 0,
          color: PALETTE.red,
          fontWeight: 500,
          fontSize: 13,
          padding: "9px 10px",
          cursor: "pointer",
          marginLeft: "auto",
        }}
      >
        Delete
      </button>
    </div>
  );
}